<div class=" text-info text-lower-initial tw-flex tw-items-center tw-flex-col">
  <p class="truncate">Ingresa una meta:</p>
  <nz-input-number
    class="input-meal-plan-goal"
    [(ngModel)]="goalValue"
    [nzMin]="0"
    nzPlaceHolder="Meta"
    (ngModelChange)="this.onChange()"
    [nzFormatter]="formatterKcal"
    [nzParser]="parserKcal"
    [nzDisabled]="disabled"
  ></nz-input-number>
  <p class="tw-text-3xs text-info tw-text-left tw-w-full tw-mt-3">Para poder ver más información es necesario ingresar una meta de calorías mayor a 0</p>
</div>
